import React, { Component } from 'react'
import TextInput from 'components/UI/TextInput'
import Link from 'components/UI/Link'
import Button from 'components/UI/Button'
import {
  handleCloseAllAlerts,
  handleErrorMessageAlert
} from 'components/UI/Alert'
import { ILoginPayload } from 'ducks/auth/types'
import ROUTES_PATH from 'routes/routePath'
import {
  FormWrapper,
  FormTitle,
  FormFooter,
  FormContent,
  FormContainer
} from './styles'
import { passwordValidation } from '../../../utils/helpers'

import { DEPARTMENT_ID } from '../../../constants'


interface IFormProps {
  onSubmit: (form: ILoginPayload) => void
}

interface IFormState {
  form: ILoginPayload
  errors: ILoginPayload
}

class SignInForm extends Component<IFormProps, IFormState> {
  constructor(props: IFormProps) {
    super(props)

    this.state = {
      form: {
        password: '',
        userName: ''
      },
      errors: {}
    }
  }

  onKeyPress = (e: any) => {
    if (e.keyCode === 13) {
      this.onSubmit()
    }
  }

  componentDidMount() {
    window.addEventListener('keypress', this.onKeyPress)
  }

  componentWillUnmount() {
    window.removeEventListener('keypress', this.onKeyPress)
  }

  render() {
    const { errors } = this.state

    return (
      <FormWrapper>
        <FormContainer>
          <FormTitle>Sign In</FormTitle>
          <FormContent>
            <TextInput
              name={'userName'}
              label={'Email Address'}
              placeholder={'Enter Email Address'}
              errorLabel={errors.userName || ''}
              handleChange={this.onUpdate}
              tooltipText={'Enter your account email address'}
            />
            <TextInput
              name={'password'}
              type={'password'}
              label={'Password'}
              placeholder={'Enter Password'}
              errorLabel={errors.password || ''}
              handleChange={this.onUpdate}
              tooltipText={'Enter password for account'}
            />
          </FormContent>
        </FormContainer>
        <FormFooter>
          <Link variant={'text'} to={ROUTES_PATH.AUTH}>
            Back to Main Page
          </Link>
          <Link variant={'text'} to={ROUTES_PATH.RESET_PASSWORD}>
            Forgot password
          </Link>
          <Button variant={'default'} onClick={this.onSubmit}>
            Sign In
          </Button>
        </FormFooter>
      </FormWrapper>
    )
  }

  private isValid = (): boolean => {
    const { form } = this.state
    const errors: ILoginPayload = {}

    if (!form.userName) {
      errors.userName = 'You must enter at least Username'
    }

    if (!form.password) {
      errors.password = 'You must enter at least password'
    }

    if (passwordValidation(form.password)) {
      // form.password && form.password.length < 8
      errors.password =
        'Please check your password. It must be longer 8 and include upper letters, ' +
        'lower letters, and number' // 'The password length is too small. Please try again.'
    }

    this.showAlertErrors(errors)

    this.setState({ errors })
    return !Object.keys(errors).length
  }

  private showAlertErrors = (errors: ILoginPayload) => {
    Object.keys(errors).forEach(prop => {
      // @ts-ignore
      if (errors[prop]) {
        // @ts-ignore
        handleErrorMessageAlert(errors[prop])
      }
    })
  }

  private onUpdate = (name: string, value: string) => {
    this.setState((prevState: IFormState) => ({
      ...prevState,
      form: {
        ...prevState.form,
        [name]: value
      },
      errors: {
        ...prevState.errors,
        [name]: ''
      }
    }))
  }

  private onSubmit = async () => {
    const { form } = this.state


    handleCloseAllAlerts()

    if (this.isValid()) {
      var payLoad = {
        'userName' : form.userName,
        'password' : form.password,
        'departmentId': DEPARTMENT_ID
      }
      this.props.onSubmit(payLoad)
    }
  }
}

export default SignInForm
